import { Component, Input } from '@angular/core';

@Component({
    selector: 'asset-link',
    templateUrl: './asset-link.component.html',
    styleUrls: ['./asset-link.component.css'],
    standalone: false
})
export class AssetLinkComponent {
  @Input() assetId: string | null | undefined = null;
}
